import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useRef } from "react";

import styles from "./modal.module.scss";

const Modal = ({ closeModal, data }) => {
  const copyLabel = useRef();

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    copyToClipBoard();
    copyLabel.current.innerText = "Link has been copied to clipboard";
    
    setTimeout(() => {
      copyLabel.current.innerText = "Copy Link";
    }, 2000);
  }

  function copyToClipBoard() {
    window.navigator.clipboard.writeText(document.location);
  }

  return (
    <div className={styles.modal__backdrop} onClick={(e) => closeModal(e)}>
      <div className={styles.modal__content}>
        <div className={styles.close_btn} onClick={(e) => closeModal(e)}>
          <FontAwesomeIcon icon={solid("xmark")} size="2x" color="#666666" />
        </div>
        <h3 className={styles.modal__title}>Save Contact Data</h3>
        <div className={styles.modal__save_methods}>
          <div className={styles.method}>
            <a target="_blank" rel="noreferrer" href={data.routeToVCF}>
              <div className={styles.icon}>
                <FontAwesomeIcon
                  icon={solid("download")}
                  size="2x"
                  className={styles.row_icon}
                  color="#666666"
                />
              </div>
              <span>Save To My Phone</span>
            </a>
          </div>
        </div>
        <h3 className={styles.modal__title}>Share Contact</h3>
        <div className={styles.modal__share_methods}>
          <div className={styles.method}>
            <a target="_blank" rel="noreferrer" href={`mailto:?body=${window.location}`}>
              <div className={styles.icon}>
                <FontAwesomeIcon
                  icon={solid("envelope")}
                  size="2x"
                  color="#666666"
                />
              </div>
              <span>Email</span>
            </a>
          </div>
          <div className={styles.method}>
            <a target="_blank" rel="noreferrer" href="#" onClick={(e) => handleClick(e)}>
              <div className={styles.icon}>
                <FontAwesomeIcon
                  icon={solid("link")}
                  size="2x"
                  color="#666666"
                />
              </div>
              <span ref={copyLabel}>Copy Link</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
